import environment from "environment/environment";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { checkEnabledChat } from "views/Services/UsersService";

function ChatSanborns({}) {
  const dispatch = useDispatch();

  const setChatHome = () => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = process.env.REACT_APP_CRISP_WEBSITE_ID;
    const script = document.createElement("script");
    script.src = "https://client.crisp.chat/l.js";
    script.async = 1;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  };

  const checkChatEnabled = async () => {
    const result = await dispatch(checkEnabledChat({}));
    if (result.payload.chatEnabled) {
      setChatHome();
    }
  };

  useEffect(() => {
    if (localStorage.getItem("userToken") !== null) {
      checkChatEnabled();
    }
  }, []);

  return <></>;
}

export default ChatSanborns;
